import React from 'react';
import { LOG_LEVELS_QUERY, LOG_LIST_QUERY } from 'features/logs/queries';
import { Card } from '@totalsoft/rocket-ui';
import ListAltIcon from '@mui/icons-material/ListAlt';
import ListBrowser, { CollectionType } from '@ts-private/list-browser';
import SystemLogComponent from './SystemLogComponent';
import ExportModalComponent from 'features/common/export/ExportModalComponent';
import { useListBrowserFunctions } from 'utils/hooks/useListBrowserFunctions';
import { useApolloFetching } from '@ts-private/list-browser-apollo-extensions';
import useLogFilters from './useLogFilters';
import logsStore from './logsStore';

const logsFetchingOptions = {
  queryOptions: { query: LOG_LIST_QUERY, name: 'logs', fetchPolicy: 'network-only' },
  collectionsOptions: [
    {
      queryOptions: { query: LOG_LEVELS_QUERY },
      name: 'logLevels',
      identifier: 'level',
      collectionType: CollectionType.Filter,
      valueKey: 'id',
      labelKey: 'name'
    }
  ]
};

const SystemLogListBrowser = () => {
  useApolloFetching(logsStore, logsFetchingOptions);
  const { textResolver } = useListBrowserFunctions();
  
  useLogFilters();

  return (
    <Card icon={ListAltIcon}>
      <ListBrowser store={logsStore} ItemComponent={SystemLogComponent} textResolver={textResolver} />
      <ExportModalComponent store={logsStore} options={logsFetchingOptions} />
    </Card>
  );
};

export default SystemLogListBrowser;
